/**
 * Diamond Product PDP - Refactored for clarity and maintainability
 */
$(document).ready(function () {
  "use strict";

  // =============================================================================
  // CONFIGURATION & CONSTANTS
  // =============================================================================

  const CONFIG = {
    SERVER_URL: "https://vportalwithclarity.com",
    CURRENCY_RATES: { US: 1, GB: 0.81, CA: 1.37, AU: 1.54 },
    STORAGE_KEYS: {
      DIAMOND_PDP: "diamond-pdp-obj",
      RELATED_DIAMONDS: "related-diamonds-obj",
      DIAMOND_INFO: "diamond-information",
      SETTING_INFO: "setting-information",
      /** Handle → variant ID map for loose diamonds (found or created). Shared with final-ring.js. */
      DIAMOND_HANDLE_VARIANTS: "diamond-handle-variants",
    },
    CERT_ID_REGEX: /^[0-9]{6,15}$/,
    LAB_LOGO_URLS: {
      IGI: "https://cdn.shopify.com/s/files/1/0757/8851/7659/files/IGI_Logo.jpg?v=1764739660",
      GIA: "https://cdn.shopify.com/s/files/1/0757/8851/7659/files/gia-certificate-logo.png?v=1757328487",
    },
  };

  const diamondClosure = theme.diamond_url;
  const serverClosure = CONFIG.SERVER_URL;
  let diamondImageUrl = "";

  // =============================================================================
  // STORAGE HELPERS (fixed get/remove diamond session)
  // =============================================================================

  const storage = {
    set: function (key, value) {
      localStorage.setItem(key, typeof value === "string" ? value : JSON.stringify(value));
    },
    get: function (key) {
      return localStorage.getItem(key);
    },
    getJSON: function (key, fallback = {}) {
      try {
        const val = localStorage.getItem(key);
        return val ? JSON.parse(val) : fallback;
      } catch {
        return fallback;
      }
    },
    remove: function (key) {
      localStorage.removeItem(key);
    },
  };

  // Legacy aliases for backward compatibility
  const helperStorage = {
    set_local_storage: (name, value) => storage.set(name, value),
    get_local_storage: (name) => storage.get(name),
    remove_local_storage: (name) => storage.remove(name),
    set_local_diamond_session: (name, value) => storage.set(name, value),
    get_local_diamond_session: (name) => storage.get(name),
    remove_local_diamond_session: (name) => storage.remove(name),
  };

  // =============================================================================
  // CURRENCY HELPERS (single source of truth)
  // =============================================================================

  function getCurrencyConversionRate() {
    return CONFIG.CURRENCY_RATES[theme.country_iso_code] ?? 1;
  }

  function formatPrice(value) {
    return value.toLocaleString("en-US");
  }

  // =============================================================================
  // DIAMOND UI HELPER
  // =============================================================================

  const helper = {
    scroll_to_diamond_tab: function () {
      $(document).on("click", ".diamond-more-info", function () {
        const target = $(".diamond-details-accordion");
        document.querySelector(".diamond-details-accordion details").setAttribute("open", true);
        document.querySelector(".diamond-details-accordion details summary").setAttribute("aria-expanded", true);
        if (target.length) {
          $("html, body").animate({ scrollTop: (target.offset().top - 180) }, 500);
        }
      });
    },

    price: function (diamond) {
      const currencySymbol = theme.country_currency_symbol;
      const rate = getCurrencyConversionRate();
      const price = parseInt(diamond.total_discounted_sales_price * rate);
      const comparePrice = parseInt(diamond.total_sales_price * rate);
      const percentOff = `${Math.round(((comparePrice - price) / comparePrice) * 100)}% OFF`;
      const bankWirePrice = parseInt(diamond.bank_wire_price_in_currency * rate);
      return [price, comparePrice, percentOff, bankWirePrice, currencySymbol];
    },

    diamond_price_html: function (diamond) {
      const [price, comparePrice, percentOff, , currencySymbol] = helper.price(diamond);
      $("#product-content").text(price);

      const priceHtml = diamond.discount_perc
        ? `<div class="price__sale">
            <span class="price-item price-item--sale">${currencySymbol}${formatPrice(price)}</span>
            <span><s class="price-item price-item--regular">${currencySymbol}${formatPrice(comparePrice)}</s></span>
            <div class="price-item price-item--discount">(${percentOff})</div>
          </div>`
        : `<div class="price__sale">
            <span class="price-item price-item--sale">$${formatPrice(price)}</span>
          </div>`;

      $(".product-single__price").html(priceHtml);
      $(".affirm-info-wrapper").html(
        `<p class="affirm-as-low-as" data-page-type="product" data-amount="${price * 100}"></p>`
      );
    },

    diamond_information: function (diamond) {
      $(".shape-info").text(diamond.shape);
      $(".carat-info").text(diamond.size);
      $(".cut-info").text(diamond.cut);
      $(".color-info").text(diamond.color);
      $(".clarity-info").text(diamond.clarity);
      $(".polish-info").text(diamond.polish);
      $(".symmetry-info").text(diamond.symmetry);
      $(".fluorescence-info").text(diamond.fluor_intensity);
      $(".table-info").text(diamond.table_percent + "%");
      $(".depth-info").text(diamond.depth_percent + "%");
      $(".measurements-info").text(diamond.measurements);
      $(".l-w-ratio-info").text(diamond.ratio);
      $(".certificate-type-info").text(diamond.lab);
      $(".lab-name").html(diamond.lab);
      $(".diamond-certificate-link").attr("href", diamond.cert_url);
      $(".product__title h1").text(diamond.diamond_name);
      $(".certificate-number,.product-single__sku span").html(diamond.cert_num);

      if (diamond?.color_intensity) {
        $(".intensity-info").text(diamond.color_intensity);
      } else {
        $(".intensity-info").closest(".color-intensity").hide();
      }

      document.title = diamond.diamond_name;

      if (diamond.diamond_name.indexOf("Lab") > -1) {
        $(".price-match-guarantee").show();
        $(".lifetime-diamond-upgrade").hide();
      } else {
        $(".price-match-guarantee").hide();
        $(".lifetime-diamond-upgrade").show();
      }

      $(".hand_diamond_img").addClass(diamond.shape.toLowerCase());
    },

    related_diamond_html: function (diamond) {
      const labels = { color: "Higher color", clarity: "Better clarity", carat: "Larger carat size" };
      const diamondLabel = labels[diamond.type] ?? "Larger carat size";
      const [price, , , , currencySymbol] = helper.price(diamond);
      const rate = getCurrencyConversionRate();
      const priceDifference = diamond.price_difference * rate;

      return `<a class="related-diamond-detail real-related-block" href="${theme.diamond_product_url}?sku=${diamond?.diamond_id}">
        <div class="related-diamond-blocks">
          <div class="related-diamond-image-wrapper">
            <div class="diamond-image-container">
              <img src="${diamond.diamond_image}" />
            </div>
          </div>
          <div class="diamond-block-details">
            <p class="diamond-block-title">${diamondLabel}</p>
            <p class="diamond-block-price diamond-block-info">
              Price: <span>${currencySymbol}${formatPrice(price)}</span>
              <span class="price-differ"> (+${currencySymbol}${formatPrice(priceDifference)})</span>
            </p>
            <p class="diamond-block-carat diamond-block-info">carat: <span>${diamond.carat_weight}</span></p>
            <p class="diamond-block-color diamond-block-info">color: <span>${diamond.color}</span></p>
            <p class="diamond-block-clarity diamond-block-info">clarity: <span>${diamond.clarity}</span></p>
          </div>
        </div>
      </a>`;
    },

    insert_related_diamond_html: function (diamondObj, pdpDiamond) {
      if (!diamondObj) {
        $(".diamond-related-products").remove();
        return false;
      }

      const [price, , , , currencySymbol] = helper.price(pdpDiamond);
      let diamondHtml = `<a class="pdp-daimond-detail real-related-block" href="${theme.diamond_product_url}?sku=${pdpDiamond?.cert_num}">
        <div class="related-diamond-blocks">
          <div class="related-diamond-image-wrapper">
            <div class="diamond-image-container">
              <img src="${pdpDiamond.image_url}" />
            </div>
          </div>
          <div class="diamond-block-details">
            <p class="diamond-block-title">Current diamond</p>
            <p class="diamond-block-price diamond-block-info">Price: <span>${currencySymbol}${formatPrice(price)}</span></p>
            <p class="diamond-block-carat diamond-block-info">carat: <span>${pdpDiamond.size}</span></p>
            <p class="diamond-block-color diamond-block-info">color: <span>${pdpDiamond.color}</span></p>
            <p class="diamond-block-clarity diamond-block-info">clarity: <span>${pdpDiamond.clarity}</span></p>
          </div>
        </div>
      </a>`;

      const sortedByType = {};
      diamondObj.forEach((d) => {
        sortedByType[d.type] = d;
      });

      let count = 0;
      ["color", "clarity", "carat"].forEach((type) => {
        const item = sortedByType[type];
        if (item && !item.remarks) {
          diamondHtml += helper.related_diamond_html(item);
          count += 1;
        }
      });

      if (count === 0) {
        $(".diamond-related-products").remove();
        return false;
      }

      $(".dummy-related-products-rendering").hide();
      $(".real-related-products-rendering").html(diamondHtml).css({ display: "flex" });
    },

    load_media: function (diamond) {
      let iframeCount = 0;
      const diamondImage = diamond?.image_url;
      diamondImageUrl = diamondImage;

      if (diamondImage) {
        const img = document.createElement("img");
        img.src = diamondImage;
        $(".main-product-dynamic-diamond-image").html(`<div class="image-wrapper"><img src="${diamondImage}"/></div>`);
        $(".diamond-thumbnil.diamond-image").append(img);
      }

      if (diamond?.lab && CONFIG.LAB_LOGO_URLS[diamond.lab]) {
        $('[data-type="diamond-certificate"] img').attr("src", CONFIG.LAB_LOGO_URLS[diamond.lab]);
      }
      if (diamond?.cert_url) {
        $('[data-type="diamond-certificate"] a').attr("href", diamond.cert_url);
      }
      if (!diamond?.video_url) {
        $(".diamond-thumbnil.diamond-360").hide();
      }
      const diamondShape = diamond?.shape;
      const diamondShapeImageSelector = $(".diamond-thumbnil.diamond-360 img");
      switch (diamondShape) {
        case "Round":
          diamondShapeImageSelector.attr("src", "https://cdn.shopify.com/s/files/1/0267/0523/1943/files/Round.jpg?v=1781091643");
          break;
        case "Radiant":
          diamondShapeImageSelector.attr("src", "https://cdn.shopify.com/s/files/1/0267/0523/1943/files/Radiant.jpg?v=1781091643");
          break;
        case "Cushion":
          diamondShapeImageSelector.attr("src", "https://cdn.shopify.com/s/files/1/0267/0523/1943/files/Cushion.jpg?v=1781091643");
          break;
        case "Oval":
          diamondShapeImageSelector.attr("src", "https://cdn.shopify.com/s/files/1/0267/0523/1943/files/Oval.jpg?v=1781091643");
          break;
        case "Emerald":
          diamondShapeImageSelector.attr("src", "https://cdn.shopify.com/s/files/1/0267/0523/1943/files/Emerald.jpg?v=1781091642");
          break;
        case "Pear":
          diamondShapeImageSelector.attr("src", "https://cdn.shopify.com/s/files/1/0267/0523/1943/files/Pear.jpg?v=1781091643");
          break;
        case "Marquise":
          diamondShapeImageSelector.attr("src", "https://cdn.shopify.com/s/files/1/0267/0523/1943/files/Marquise.jpg?v=1781091642");
          break;
        case "Princess":
          diamondShapeImageSelector.attr("src", "https://cdn.shopify.com/s/files/1/0267/0523/1943/files/Princess.jpg?v=1781091642");
          break;
      }

      console.log("diamond", diamond);

      const windowWidth = Math.floor($(".product-single__diamond-group .diamond-image-wrapper").width());
      let videoUrlWithSize = diamond.video_url || "";
      try {
        if (windowWidth < 550 && videoUrlWithSize.indexOf("loupe360.com") > -1) {
          const parts = diamond.video_url.split("/video/");
          videoUrlWithSize = parts[0] + `/video/${windowWidth}/${windowWidth}/true`;
        } else if (videoUrlWithSize.indexOf("loupe360.com") > -1) {
          videoUrlWithSize = videoUrlWithSize + "/true";
        }
      } catch (e) {
        // Video URL parsing failed, use original
      }

      $(".diamond-thumbnil:not(.diamond-certificate)").on("click", function () {
        $(".diamond-thumbnil").removeClass("active");
        $(".diamond-image-wrapper > [class*=diamond]").hide();
        const dataType = $(this).data("type");
        $(this).addClass("active");
        $("." + dataType).show();

        if (!iframeCount && dataType === "diamond-iframe") {
          $(".diamond-iframe iframe").attr("src", videoUrlWithSize);
          iframeCount += 1;
        }
      });

      const softSlider = document.getElementById("slider");
      if (softSlider) {
        const diamondCaratImagesObj = JSON.parse($("#diamond-image-json").text());
        const diamondShape = diamondCaratImagesObj[diamond.shape];
        const formatForSlider = {
          from: (v) => Number(v),
          to: (v) => v.toFixed(2),
        };
        noUiSlider.create(softSlider, {
          start: 1,
          range: {
            min: [0, 0.25],
            "12.5%": [1, 0.25],
            "25%": [2, 0.25],
            "37.5%": [3, 0.25],
            "50%": [4, 0.5],
            "62.5%": [5, 0.5],
            "75%": [6, 0.5],
            "87.5%": [7, 1],
            max: [8],
          },
          step: 1,
          tooltips: true,
          format: formatForSlider,
          pips: { mode: "steps", format: formatForSlider },
        });
        softSlider.noUiSlider.on("update", function (values) {
          $(".diamond-on-hand img").attr("src", diamondShape[values[0]]);
        });

        const imageContainer = document.querySelector(".load-diamond-images");
        if (imageContainer) {
          for (const key in diamondShape) {
            const img = document.createElement("img");
            img.src = diamondShape[key];
            imageContainer.appendChild(img);
          }
        }
      }
    },

    section_tab_slider: function () {
      const slider = $(".diamond-education__content-wrapper");
      if (slider.length) {
        slider.slick({ slidesToShow: 1, slidesToScroll: 1, arrows: false, fade: true });
      }
      $(".diamond-education__tab").on("click", function () {
        const dataTab = $(this).data("tab");
        $(this).closest(".shopify-section").find(".diamond-education__tab").removeClass("active");
        $(this).addClass("active");
        const slideIndex = $(`.diamond-education__content[data-type="${dataTab}"]`).data("slick-index");
        $(this).closest(".shopify-section").find(".diamond-education__content-wrapper").slick("slickGoTo", slideIndex);
      });
    },

    mobileImageSlide: function () {
      if ($(window).width() < 750) {
        $(".diamond-education__tabs").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: true,
        });
      }
    },
  };

  // Merge storage helpers into helper for backward compatibility
  Object.assign(helper, helperStorage);

  // =============================================================================
  // WORK DAY CALCULATOR
  // =============================================================================

  const calculator = {
    workDaysAdded: 0,
    month: ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"],
    monthFull: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    weekday: ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"],
    weekdayFull: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    ukHolidays: ["2025-11-27", "2025-12-25", "2026-01-01"],
    curDate: null,

    formatDate: function (date) {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      return `${date.getFullYear()}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    },

    addWorkDay: function () {
      this.curDate.setDate(this.curDate.getDate() + 1);
      const dateStr = this.formatDate(this.curDate);
      const isWeekday = this.curDate.getDay() !== 0 && this.curDate.getDay() !== 6;
      const isNotHoliday = this.ukHolidays.indexOf(dateStr) === -1;
      if (isNotHoliday && isWeekday) {
        this.workDaysAdded++;
      }
    },

    getNewWorkDay: function (daysToAdd) {
      this.curDate = new Date();
      this.workDaysAdded = 0;
      while (this.workDaysAdded < daysToAdd) {
        this.addWorkDay();
      }
      return [
        this.weekday[this.curDate.getDay()],
        this.month[this.curDate.getMonth()],
        this.curDate.getDate(),
        this.weekdayFull[this.curDate.getDay()],
        this.monthFull[this.curDate.getMonth()],
      ];
    },
  };

  // =============================================================================
  // DIAMOND DATA & API
  // =============================================================================

  function updateRelatedDiamondsObj(diamondId, relatedDiamondObj) {
    const obj = storage.getJSON(CONFIG.STORAGE_KEYS.RELATED_DIAMONDS, {});
    obj[diamondId] = relatedDiamondObj;
    storage.set(CONFIG.STORAGE_KEYS.RELATED_DIAMONDS, obj);
  }

  function fetchRelatedDiamondData(diamondId, pdpDiamond) {
    const jsonData = { filter: [{ diamond_id: diamondId },{ brand_id: 2 }] };
    fetch(`${serverClosure}/diamondrecommendation`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((data) => {
        const [a, b, c] = data;
        helper.insert_related_diamond_html([a, b, c], pdpDiamond);
        updateRelatedDiamondsObj(diamondId, [a, b, c]);
      })
      .catch(() => {
        $(".diamond-related-products").remove();
      });
  }

  function loadRelatedDiamonds(diamondId, pdpDiamond) {
    const relatedList = storage.getJSON(CONFIG.STORAGE_KEYS.RELATED_DIAMONDS, null);
    if (!relatedList || !relatedList[diamondId]) {
      fetchRelatedDiamondData(diamondId, pdpDiamond);
    } else {
      helper.insert_related_diamond_html(relatedList[diamondId], pdpDiamond);
    }
  }

  function showDiamondInfoOnPDP(selectedDiamond) {
    if (!selectedDiamond?.cert_num) {
      $("body").addClass("diamond-not-available");
      return false;
    }
    $("body").addClass("diamond-available");
    helper.load_media(selectedDiamond);
    helper.diamond_price_html(selectedDiamond);
    helper.diamond_information(selectedDiamond);
    ensureLooseProductExists(selectedDiamond);
  }

  function setDiamondPdpInformation(diamondInfo) {
    if (!diamondInfo) {
      $("body").addClass("diamond-not-available");
      return false;
    }
    const obj = storage.getJSON(CONFIG.STORAGE_KEYS.DIAMOND_PDP, {});
    obj[diamondInfo.cert_num] = diamondInfo;
    storage.set(CONFIG.STORAGE_KEYS.DIAMOND_PDP, obj);
  }

  function fetchDiamondData(diamondId) {
    const jsonData = { filter: [{ diamond_id: diamondId },{ brand_id: 2 }] };
    fetch(`${serverClosure}/fetchparticulardiamonddetail/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((data) => {
        const diamondInfo = data.data?.liveDiamondData?.diamond?.[0];
        if (diamondInfo) {
          setDiamondPdpInformation(diamondInfo);
          showDiamondInfoOnPDP(diamondInfo);
          loadRelatedDiamonds(diamondId, diamondInfo);
        } else {
          $("body").addClass("diamond-not-available");
        }
      })
      .catch(() => {});
  }

  // =============================================================================
  // LOOSE PRODUCT - Check backend first, create only if not exists (on page load)
  // =============================================================================

  function checkProductExistsInBackend(handle) {
    return fetch(`/products/${handle}.json`)
      .then((res) => (res.ok ? res.json() : null))
      .catch(() => null);
  }

  /** Persists handle → variant ID in a single object so final-ring can skip fetch/create when possible. */
  function setDiamondHandleVariant(handle, variantId) {
    const map = storage.getJSON(CONFIG.STORAGE_KEYS.DIAMOND_HANDLE_VARIANTS, {});
    map[handle] = String(variantId);
    storage.set(CONFIG.STORAGE_KEYS.DIAMOND_HANDLE_VARIANTS, map);
  }

  function ensureLooseProductExists(selectedDiamond) {
    const formattedName = selectedDiamond.diamond_name.toLowerCase().replace(/\./g, "-").replace(/\s+/g, "-");
    const handle = `diamond-${formattedName}-${selectedDiamond.cert_num}`;

    return checkProductExistsInBackend(handle).then((response) => {
      const existingVariantId = response?.product?.variants?.[0]?.id;
      if (existingVariantId) {
        setDiamondHandleVariant(handle, existingVariantId);
        return existingVariantId;
      }

      const postData = buildFinalDiamondInfo(selectedDiamond);
      return fetch(`${diamondClosure}/api/create-product`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(postData),
      })
        .then((res) => res.json())
        .then((data) => {
          const variantId = data?.product?.variants?.[0]?.id;
          if (variantId) {
            setDiamondHandleVariant(handle, variantId);
          }
          return variantId;
        })
        .catch(() => null);
    });
  }

  function buildFinalDiamondInfo(selectedDiamond) {
    const price = parseInt(selectedDiamond.total_discounted_sales_price);
    const comparePrice = parseInt(selectedDiamond.total_sales_price);
    const actualComparePrice = comparePrice > price ? selectedDiamond.total_sales_price : "";
    const formattedName = selectedDiamond.diamond_name
      .toLowerCase()
      .replace(/\./g, "-")
      .replace(/\s+/g, "-");
    const handle = `diamond-${formattedName}-${selectedDiamond.cert_num}`;

    return {
      product: {
        title: selectedDiamond.diamond_name,
        handle,
        body_html: `<h2>Diamond Detail:</h2><ul>
          <li>diamond_name ${selectedDiamond?.diamond_name}</li>
          <li>Shape ${selectedDiamond?.shape}</li>
          <li>measurements ${selectedDiamond?.measurements}</li>
          <li>Carat ${selectedDiamond?.size}</li>
          <li>Cut ${selectedDiamond?.cut}</li>
          <li>Color ${selectedDiamond?.color}</li>
          <li>Clarity ${selectedDiamond?.clarity}</li>
          <li>Polish ${selectedDiamond?.polish}</li>
          <li>Symmetry ${selectedDiamond?.symmetry}</li>
          <li>Fluorescence ${selectedDiamond?.fluor_intensity}</li>
          <li>Table ${selectedDiamond?.table_percent}%</li>
          <li>Depth ${selectedDiamond?.depth_percent}%</li>
          <li>L/W Ratio ${selectedDiamond?.ratio}</li>
          <li>Certificate type ${selectedDiamond?.lab}</li>
          <li>Certificate Number ${selectedDiamond?.cert_num}</li>
          <li>Price ${selectedDiamond?.total_discounted_sales_price}</li>
          <li>Compare Price ${selectedDiamond?.total_sales_price}</li>
          <li>Cert_url ${selectedDiamond?.cert_url}</li>
          <li>Vault Discount ${selectedDiamond?.vaultDiscount}</li>
        </ul>`,
        vendor: "Enchanted Disney Fine Jewelry",
        product_type: "Diamond",
        tags: ["hidden-on-front-end", "ring diamond", selectedDiamond?.lab],
        variants: [
          {
            price,
            compare_at_price: actualComparePrice,
            inventory_management: "shopify",
            inventory_policy: "deny",
            inventory_quantity: 1,
            sku: selectedDiamond.cert_num,
            weight: selectedDiamond.size,
            weight_unit: "g",
            title: "rgl-diamond-110718",
          },
        ],
        images: [{ src: diamondImageUrl }],
      },
    };
  }

  // =============================================================================
  // INITIALIZATION
  // =============================================================================

  helper.mobileImageSlide();
  helper.section_tab_slider();
  helper.scroll_to_diamond_tab();

  const newWorkDay7 = calculator.getNewWorkDay(9);
  const newWorkDay8 = calculator.getNewWorkDay(10);
  $(".product-form_ship-loose-timeline b").text(`${newWorkDay7[0]}, ${newWorkDay7[1]} ${newWorkDay7[2]}`);
  $(".product-form_ship-in-ring-timeline b").text(`${newWorkDay8[0]}, ${newWorkDay8[1]} ${newWorkDay8[2]}`);
  $("#properties-ship-by").val(`${newWorkDay7[3]}, ${newWorkDay7[4]} ${newWorkDay7[2]}`);

  // =============================================================================
  // DIAMOND PDP PAGE LOGIC
  // =============================================================================

  const windowLocation = window.location.href;
  if (windowLocation.indexOf(theme.diamond_product_url) === -1) {
    return;
  }

  const diamondLink = (windowLocation.split(theme.diamond_product_url)[1] || "").replace(/^\//, "");
  const skuMatch = diamondLink.match(/[?&]sku=([^&]+)/);
  const diamondId = skuMatch ? skuMatch[1].replace(/\//g, "") : "";

  if (!CONFIG.CERT_ID_REGEX.test(diamondId)) {
    $("body").addClass("diamond-not-available");
    return;
  }

  const diamondList = storage.getJSON(CONFIG.STORAGE_KEYS.DIAMOND_PDP, null);

  if (diamondList && diamondList[diamondId]) {
    const selectedDiamond = diamondList[diamondId];
    setDiamondPdpInformation(selectedDiamond);
    showDiamondInfoOnPDP(selectedDiamond);
    loadRelatedDiamonds(diamondId, selectedDiamond);
  } else {
    fetchDiamondData(diamondId);
  }

  // Add loose diamond to ring
  $(".product-form__add-to-diamond button").on("click", function () {
    $(this).addClass("loading");
    $(this).find(".loading__spinner").removeClass("hidden");
    const list = storage.getJSON(CONFIG.STORAGE_KEYS.DIAMOND_PDP, {});
    const pdpDiamond = list[diamondId];
    if (!pdpDiamond) {
      $(this).closest(".product-form__add-to-diamond").removeClass("button-active");
      return;
    }
    $(this).closest(".product-form__add-to-diamond").addClass("button-active");
    storage.set(CONFIG.STORAGE_KEYS.DIAMOND_INFO, pdpDiamond);

    const ringSettings = storage.get(CONFIG.STORAGE_KEYS.SETTING_INFO);
    if (ringSettings) {
      try {
        const ringSettingsJson = JSON.parse(ringSettings);
        const variantId = ringSettingsJson.variants?.[pdpDiamond.shape];
        if (variantId && ringSettingsJson.url) {
          window.location.href = `${ringSettingsJson.url}?variant=${variantId}&view=final-ring&diamond=${pdpDiamond.cert_num}`;
          return;
        }
      } catch (e) {
        // Invalid JSON, fall through to collections
      }
    }
    window.location.href = `/collections/${theme.ring_setting_handle}`;
  });
});
